import React from 'react';
import PropTypes from 'prop-types';

import MInputField from '../../molecules/fields/_molecules.input-field';

export default function OUserInfo({
	email,
	password,
	onPasswordChange,
	onEmailChange,
}) {
	return (
		<article className="o-contact-basic">
			<MInputField
				id="iEmail"
				type="email"
				label="Email"
				value={email}
				placeholder="johndoe@gmail.com"
				required
				onChange={onEmailChange}
			/>
			<MInputField
				id="iPassword"
				type="password"
				label="Wachtwoord"
				value={password}
				required
				onChange={onPasswordChange}
			/>
		</article>
	);
}

OUserInfo.propTypes = {
	email: PropTypes.string,
	password: PropTypes.string,
	onPasswordChange: PropTypes.func,
	onEmailChange: PropTypes.func,
};

OUserInfo.defaultProps = {
	email: undefined,
	password: undefined,
	onPasswordChange: undefined,
	onEmailChange: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.user-info.js